/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Colors_HintInputs */



/**
* | output |
* | --- |
* | "Five roles drive the whole deck." |
*
* @param {Presentation_Template_Colors_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_colors_hint = /** @type {((inputs?: Presentation_Template_Colors_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Colors_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fünf Rollen prägen das gesamte Deck.")
	return /** @type {LocalizedString} */ ("Five roles drive the whole deck.")
});